import { get } from 'lodash';

import { Thesaurus } from '@skinsoft/types';

export const identifer = (thesaurus: Thesaurus) =>
    get(thesaurus, 'thesaurusCS.identifier', null)
